import React, { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { CustomTable, Loader } from 'src/components'
import { planePreviewListColumns, carPreviewListColumns, parcelPreviewListColumns } from 'src/core/table-columns'
import {
  buildPreviewList, isCarCalculeType, isPlaneCalculeType, isParcelCalculeType
} from 'src/features'
import ResponseListHeader from '../DownloadCertificatesStep/ResponseListHeader/ResponseListHeader'

const ConfirmTransactionStep = () => {
  const dispatch = useAppDispatch()
  const isCarPreview = useAppSelector(isCarCalculeType)
  const isPlanePreview = useAppSelector(isPlaneCalculeType)
  const isParcelPreview = useAppSelector(isParcelCalculeType)

  const {
    planeKeys, carKeys, parcelKeys,
    excelData, loadingPreview, preViewList
  } = useAppSelector((state) => state.admin.massiveCalculation)

  useEffect(() => {
    if (isCarPreview) {
      dispatch(buildPreviewList('CARS', carKeys, excelData))
    } else if (isPlanePreview) {
      dispatch(buildPreviewList('PLANE', planeKeys, excelData))
    } else if (isParcelPreview) {
      dispatch(buildPreviewList('PARCEL', parcelKeys, excelData))
    }
  }, [
    dispatch, planeKeys, excelData,
    carKeys, isCarPreview, isPlanePreview,
    parcelKeys, isParcelPreview
  ])

  const getPreviewColumns = () => {
    return isCarPreview ? carPreviewListColumns :
      isPlanePreview ? planePreviewListColumns :
        isParcelPreview ? parcelPreviewListColumns : []
  }

  return (
    <>
      {loadingPreview ? (
        <Loader />
      ) : (
        <>
          {/* Header Content */}
          <ResponseListHeader
            loading={false}
            length={preViewList?.length}
            handleCsvDownload={null}
          />
          <CustomTable
            columns={getPreviewColumns()}
            dataSource={preViewList}
          />
        </>
      )}
    </>
  )
}

export default ConfirmTransactionStep
